import type Luminary from '@lumen5/luminary';

import type { Tool } from '../tools/Tool';

import { EditHtmlAssetTool } from './EditHtmlAssetTool';
import { ReadHtmlAssetTool } from './ReadHtmlAssetTool';
import { WriteHtmlAssetTool } from './WriteHtmlAssetTool';
import { WritePlanTool } from './WritePlanTool';

import type { AppDispatch, GetRootState } from 'js/src/libs/RootState';

export function buildDesignAuthoringTools(
    luminary: Luminary,
    dispatch: AppDispatch,
    getState: GetRootState,
): Tool[] {
    const args = { luminary, dispatch, getState };
    return [
        new WritePlanTool(args),
        new WriteHtmlAssetTool(args),
        new EditHtmlAssetTool(args),
        new ReadHtmlAssetTool(args),
    ];
}
